import Vue from 'vue'
import VueRouter from 'vue-router'

import ExchangeSuccess from '../views/exchange-success/index.vue'
import PointsMall from '../views/points-mall/index.vue'
import CardDetail from '../views/card-detail/index.vue'
import PointsDetailAll from '../views/points-detail-all/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/order/:id',
    name: 'exchange-success',
    component: ExchangeSuccess
  },
  {
    path: '/home',
    name: 'points-mall',
    component: PointsMall
  },
  {
    path: '/card/:id',
    name: 'card',
    component: CardDetail,
    props: true
  },
  {
    path: '/all',
    name: 'points-all',
    component: PointsDetailAll
  }
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

export default router
